import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationTriangleIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';

const SessionExpiredModal = ({ isVisible, onClose }) => {
    const navigate = useNavigate();

    const handleReconnect = () => {
        onClose();
        navigate('/login');
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
            
            {/* Modal */}
            <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
                <div className="text-center">
                    {/* Icône d'avertissement */}
                    <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <ExclamationTriangleIcon className="w-8 h-8 text-orange-600" />
                    </div>
                    
                    {/* Titre */}
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Session expirée
                    </h3>
                    
                    {/* Message */}
                    <p className="text-gray-600 mb-6">
                        Votre session a expiré pour des raisons de sécurité. 
                        Veuillez vous reconnecter pour continuer.
                    </p>
                    
                    {/* Boutons */}
                    <div className="flex flex-col sm:flex-row gap-3">
                        <button
                            onClick={handleReconnect}
                            className="flex-1 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-3 px-6 rounded-xl font-semibold transition-all duration-200 flex items-center justify-center gap-2"
                        >
                            <ArrowRightOnRectangleIcon className="w-5 h-5" />
                            Se reconnecter
                        </button>
                        
                        <button
                            onClick={onClose}
                            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 px-6 rounded-xl font-semibold transition-all duration-200"
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
